export default __webpack_public_path__ + "static/media/reading.33e5b566.svg";